<script>
  import LookupSelect from '../generic/LookupSelect.vue'

  export default {
    components: {
      LookupSelect,
    },
    computed: {
      options () {
        return this.$store.getters[`${this.store}/options`]
      },
      selected () {
        return this.$store.getters[`${this.store}/selected`]
      },
      selectedItem () {
        return this.$store.getters[`${this.store}/selectedItem`]
      },
      searchValue () {
        return this.$store.getters[`${this.store}/search`]
      },
    },
    methods: {
      deleteRow(item) {
        this.del(item).then(() => this.getPage())
      },
      select (value) {
        this.$store.dispatch(`${this.store}/select`, value)
      },
      search (search) {
        this.$store.dispatch(`${this.store}/search`, search || null)
      }
    },
    props: {
      store: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        required: true
      },
      searchPlaceholder: {
        type: String,
        required: true
      },
    }
  }
</script>
<template>
  <lookup-select
    :placeholder="placeholder"
    :search-placeholder="searchPlaceholder"
    :icon="true"
    optionLabel="addr1"
    :clearButton="true"
    :options="options"
    :selected="selected"
    :selected-item="selectedItem"
    :search-value="searchValue"
    @select="select"
    @search="search"
  >
    <template v-slot:selected-item="slotProps">
      <slot name="selected-item" v-bind:item="slotProps.item">{{slotProps.item}}</slot>
    </template>
    <template v-slot:item="slotProps">
      <slot name="item" v-bind:item="slotProps.item">{{slotProps.item}}</slot>
    </template>
  </lookup-select>
</template>
